const Loading = () => {
    return (
        <div>
            <img
                src="/assets/loading.gif"
                alt="로딩이미지"
            />
        </div>
    );
};

export default Loading;
